<style scoped>
@media (max-width: 768px) {
  .block-container {
    margin-top: 1.5rem;
  }
}
</style>

<template>
  <title-container title="Dashboard" icon="address-card">
    <b-row>
      <b-col lg="12" md="12" xl="6">
        <profile class="block-container raised" />
      </b-col>
      <b-col lg="12" md="12" xl="6">
        <loan-stats v-if="allowedToSeeStats" class="block-container raised"/>
      </b-col>
    </b-row>
    <b-row v-if="showLoanSummary">
      <b-col lg="12" md="12" xl="4" class="mt-4">
        <loan-summary
          v-if="showLoanSummary"
          class="block-container inherit-min-height raised m-0 pb-3"
        />
      </b-col>
      <b-col lg="12" md="12" xl="8" class="mt-4">
        <profile-page-switcher />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col lg="12" md="12" class="mt-4">
          <profile-page-switcher />
        </b-col>
    </b-row>
  </title-container>
</template>

<script>
import TitleContainer from '@/components/utils/TitleContainer';
import Profile from '@/components/profile/sections/profile/Profile';
import LoanStats from '@/components/profile/sections/stats/LoanStats';
import LoanSummary from '@/components/profile/sections/loan_summary/LoanSummary';
import ProfilePageSwitcher from '@/components/profile/sections/ProfilePageSwitcher';
import { APPLICATION_READ, LOANS_READ } from '@/libs/permissions_list';

import { DEFINE_APPLICATION_ALERT } from '@/vuex/modules/alerts/types/actions';

const SignApplicationTab = 7;
const SignApplicationPageName = 'SignApplication';

export default {
  components: {
    TitleContainer,
    Profile,
    LoanStats,
    LoanSummary,
    ProfilePageSwitcher,
  },
  data() {
    return {
      applicationIndex: 0,
    };
  },
  mounted() {
    if (this.$route.name === SignApplicationPageName) {
      this.applicationIndex = SignApplicationTab;
    }
  },
  computed: {
    loanAppDoc() {
      return this.$store.getters.documents.find(doc => doc.type === 'Loan App') || { approvedCount: 0 };
    },
    allowedToSeeStats() {
      return this.$permissions.checkPermissions([LOANS_READ]);
    },
    showLoanSummary() {
      return this.$permissions.checkPermissions([LOANS_READ]) && this.loanAppDoc.approvedCount;
    },
    showApplicationProgress() {
      return this.$permissions.checkPermissions([APPLICATION_READ]);
    },
  },
  methods: {
    disableApplicationAlert() {
      this.$store.dispatch(DEFINE_APPLICATION_ALERT, { enabled: false });
    },
    bAppItemClicked(item) {
      this.$router.push({
        name: 'BorrowerApplication',
        query: { tab: item.tab },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/ProfilePage.vue